import React from "react";
import { useParams } from "react-router-dom";
import { useGetProductByIdQuery } from "../../../services/productListApiSice";
import { SpareDetail } from "../../../component/spares/spareDetail/SpareDetail";
import { LoadingSpinner } from "../../../component/spinners/LoadingSpinner";
import classes from "./productDetailPage.module.css";

export const ProductDetailPage = () => {
  const { category, productId } = useParams();
  const { data, isFetching, isError, error } = useGetProductByIdQuery({
    category,
    request_id: productId,
  });

  console.log("API Response:", data);
  console.log("Product Data:", data?.data);

  // Loading state
  if (isFetching) {
    return (
      <div className={classes.box}>
        <LoadingSpinner />
        <p>Loading product details...</p>
      </div>
    );
  }

  // Error state
  if (isError) {
    return (
      <div className={classes.box}>
        <div className={classes.error}>
          <h2>Error Loading Product</h2>
          <p>{error?.data?.message?.displayMessage || error?.message || "Failed to load product"}</p>
        </div>
      </div>
    );
  }

  // No data state
  if (!data) {
    return (
      <div className={classes.box}>
        <div className={classes.empty}>
          <h2>Product Not Found</h2>
          <p>The requested product could not be found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.box}>
      <SpareDetail spareData={data} />  {/* Changed from data?.data to data.data */}
    </div>
  );
};